document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-flavor-slider]').forEach(function (section) {
    var swiperEl = section.querySelector('.flavor-slider__swiper');

    if (!swiperEl) return;
    if (swiperEl._swiperInit) return;
    swiperEl._swiperInit = true;

    new Swiper(swiperEl, {
      slidesPerView: 'auto',            
      spaceBetween: 16,
      loop: true,
      grabCursor: true,      
      watchOverflow: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      navigation: {        
        prevEl: section.querySelector('.flavor-slider__btn--prev'),
        nextEl: section.querySelector('.flavor-slider__btn--next')
      },
      breakpoints: {
        769: {
          spaceBetween: 42        
        }        
      }
    });
  });
});
